<template>
  <div class="testPage">testPage</div>
  <el-upload
        action=""
        :multiple="false"
        accept=".zip"
        :limit="1"
        :before-upload="beforeAvatarUpload"        
        :http-request="componentImport"
        :show-file-list="false"
        :file-list="fileList"
        style="display:inline-block;margin:0 10px">
        <el-button size="small" type="success" icon="el-icon-upload">读取压缩包</el-button>
    </el-upload>
    <!-- <iframe width="600" height="800" :src="testUrl"></iframe> -->
   
    <!--  -->
    <a href="../../../../coverage_result-1/index.html">测试一下</a>

     <div width="600" height="800" v-html="testUrl"></div>
    
</template>
<script>
// downLoadFile
import { getOSSFileList, getOSSUrl, downLoadFile } from "@/request/api";
//getUrlData,
import {  getUrlData } from "@/request/axiosApi"
// import FastText from 'fast-text-encoding'
// import fastText from 'fast-text-encoding';
// import { saveAs } from 'file-saver'
import JSZip from 'jszip'
// import path from "path";
// const path= require("path") 
// import * as JSZip from "@zip.js/zip.js/dist/zip";
// /dist/zip
export default {
  name: "testPage",
  data() {
    return {
      testUrl: ""
    };
  },
  methods: {
    largeuint8ArrToString(uint8arr, callback) {
      var bb = new Blob([uint8arr]);
      var f = new FileReader();
      f.onload = function (e) {
        callback(e.target.result);
      };

      f.readAsText(bb);
    },

    // 读取压缩文件
        async componentImport(file){

          // const executableFullPath = document.getElementById("path");
          // console.log("executableFullPath = ", executableFullPath)
          // const path1 = "../../../../coverage_result-1/index.html"
          // window.open(path1)

          console.log("file 222= ", file);
            // 引用js
            const zip = new JSZip()
            // 解压Zip压缩包，参数默认是二进制
            const zipData = await zip.loadAsync(file.file)
            console.log("zipData = ", zipData)
            // zip.folder("NYY").file("hello.txt", "Hello World\n");
            //  console.log("zip = ", zip)
           //coverage_result/index.html
            const dd3 = await zip.file("coverage_result/index.html").async("blob")
            // const dd3 = zipData.files["coverage_result/Eden/include/ord/OpenRoad.hh.func.html"]
            console.log("dd3 = ", dd3)
            const urlObject = window.URL || window.webkitURL || window;
            const newUrl = urlObject.createObjectURL(dd3);

            console.log("newUrl = ", newUrl)
            this.testUrl = newUrl;
            const dd = await getUrlData(newUrl, true);
            this.testUrl = dd
            // const ll = await getUrlData(newUrl, false);

            // const a = document.createElement("a");
            // const
            // //4. 下载文件
            // let el = document.createElement("a");
            // el.href = newUrl;
            // el.download = "icb";
            // el.click();
            // urlObject.revokeObjectURL(newUrl);       
            // for (let key in zipData.files) {
            //     if (!zipData.files[key].dir) {  // 判断是否是目录
            //         if (/\.(xlsx)$/.test(zipData.files[key].name)) { // 判断是否是xlsx文件
            //             let base = await zip.file(zipData.files[key].name).async('base64') // 以base64输出文本内容
            //             // Base64 转 File 对象
            //             const result = this.dataURLtoFile(base, zipData.files[key].name)
            //             console.log(result,'最终解压后的File对象')
            //         }
            //     }
            // }
            // // 清空文件列表            
            // this.fileList = []
        },
        dataURLtoFile(dataURL, fileName, fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            /**
             * 注意：【不同文件不同类型】，例如【图片类型】就是`data:image/png;base64,${dataURL}`.split(',')
             * 下面的是【excel文件(.xlsx尾缀)】的文件类型拼接，一个完整的 base64 应该
             * 是这样的,例如： data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAABGdBTUEAALGPC/xhBQAAACBjSFJN
             */ 
            const arr = `data:${fileType};base64,${dataURL}`.split(',')
            const mime = arr[0].match(/:(.*?);/)[1]
            const bstr = atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            let blob = new File([u8arr], fileName, { type: mime })
            // const ll = 
            return blob
        }      

    // async getZIPFileNames(file: Blob | File | string): Promise<any> {
    //   let reader: any;
    //   if (typeof file === "string") {
    //     reader = new JSZip.ZipReader(new JSZip.HttpReader(file, { useXHR: false }));
    //   } else if (file instanceof Blob) {
    //     reader = new JSZip.ZipReader(new JSZip.BlobReader(file));
    //   }
    //   const entries: any = await reader.getEntries();
    //   reader.close();
    //   return entries.map((entry: any) => entry.filename);
    // }
  },
  async created() {

    // const data = await downLoadFile(
    //   "icb-devops",
    //   "test/coverage_result.tar.gz"
    // );
    // console.log("downLoadFile data======== ", data);

    // const list = await getOSSFileList("icb-devops", "Eden")
    // console.log("list data======== ", list);
    // const list2 = list.objects.filter((item) => {
    //   return item.name.includes(".json")
    // })
    // console.log("list2 = ", list2)

    // list2.map(item => {
    //   const arr = item.name.split("/")
    //   item.pathNumber = arr[1]
    //   item.prNumber = arr[2]
    // })
    // console.log("list2 111= ", list2)
    
    // list2.sort((m1, m2)=> {
    //   return m1.pathNumber - m2.pathNumber
    // })
    // console.log("list2 2222= ", list2)
    // // const list3 = [...list2]
    // const list4 = []
    // for (const item of list2) {
    //   list4.push(item.pathNumber)
    // }
    // console.log("list4 = ", [... new Set(list4)])
    // const list5 = [... new Set(list4)]
    
    // for (const pathNumber of list5) {
    //   let maxItem = {}
    //   let maxPrNumber = 0
    //   for (const item of list2) {
    //     if (pathNumber ==  item.pathNumber) {
    //       if (item.prNumber >= maxPrNumber) {
    //         maxPrNumber = item.prNumber
    //         maxItem =  item
    //       }
    //     }
    //   }
    //   const url = await getOSSUrl("icb-devops", maxItem.name)
    //   // console.log(url)
    //   const d = await getUrlData(url, true);
    //   // console.log("getJSONData d======== ", d);
    //   maxItem.jsonModel = d;
    //   console.log("maxItem ... = ", maxItem)
    // }

    /*
    etag: "\"6FA1283267DBD654ED2BBA9C9CB470A3\""
lastModified: "2022-07-05T09:05:12.000Z"
name: "Eden/385/144/coverage_results.tar.zst"
owner: {id: '1450424585376992', displayName: '1450424585376992'}
size: 22392461
storageClass: "Standard"
type: "Normal"
url: "https://icb-devops.oss-cn-shanghai.aliyuncs.com/Eden/385/144/coverage_results.tar.zst"
    */

  //  path.join('./static', "testclass")

   const list = await getOSSFileList(this.$DataString.regressionBucket, "Eden/1/1/")
   console.log("list data======== ", list);

   const url = await getOSSUrl(this.$DataString.regressionBucket, "Eden/1/1/coverage_results/Eden/src/Banyan/src/Banyan.cpp.func-sort-c.html")
   console.log(url)

   const dd = await getUrlData(url, false);
   console.log("dd = ", dd)
   
   const dd2 = await downLoadFile(this.$DataString.regressionBucket, "Eden/385/144/coverage_results.tar.zst")
  //  const dd = await downLoadFile(this.$DataString.regressionBucket, "Eden/385/144/coverage_results.tar.zst")
   console.log("dd2 ======== ", dd2)


  //  const path1 = "../../../../coverage_result-1/index.html"
  //  const path2 = "///Users/wanzhengshou/Desktop/coverage_result-1/index.htm"
  // // window.open(path1)
  // this.testUrl = path1
  //  const files = new window.File([dd2], "tester.zip", {type: 'application/zip'})
  //  console.log("files 111= ", files)
  //  const zip = new JSZip()
  //  const zipData = await zip.loadAsync(files)
  //  console.log("zipData = ", zipData)
   /*
   base64: string;
    string: string;
    text: string;
    binarystring: string;
    array: number[];
    uint8array: Uint8Array;
    arraybuffer: ArrayBuffer;
    blob: Blob;
    nodebuffer: Buffer;
   */
   
    // const urlObject = window.URL || window.webkitURL || window;
    // // const content = new Blob([dd], {
    // //           type: "application/octet-stream",
    // //         });
    // const newUrl = urlObject.createObjectURL(files);
    // console.log("newUrl = ", newUrl)
    //  //4. 下载文件
    //         let el = document.createElement("a");
    //         el.href = newUrl;
    //         el.download = "icb";
    //         el.click();
    //         urlObject.revokeObjectURL(newUrl);

    // const reader = new FileReader()
    // // readAsText是个异步操作，只有等到onload时才能显示数据。
    // reader.readAsDataURL(files)
    // reader.onload = function () {
    //   //当读取完成后回调这个函数,然后此时文件的内容存储到了result中,直接操作即可,此处this指向reader，_that指向vue data，this.result就是文件的内容
    //   console.log("this.result ===== ", this.result)
    //   // _that.coder.setValue(this.result)
    // }

    // console.log("list3 333= ", list3)
   
    // let pathNumber = list2[0].pathNumber
    // let prNumber = list2[0].prNumber
    
    // 获取zip内文件名  BlobReader Uint8ArrayReader
    // const reader = new JSZip.ZipReader(new JSZip.HttpReader(data));
    // console.log("reader = ", reader)
    // const tt = new JSZip.HttpReader(data)
    // console.log("tt = ", tt)
    // const reader = new JSZip.ZipReader(new JSZip.Uint8ArrayReader(data));
    // console.log("reader = ", reader)
    // // get all entries from the zip
    // // const entries = await reader.getEntries();
    // // console.log("entries = ", entries)
    // const entries2 = reader.getEntriesGenerator()
    // console.log("entries2 = ", entries2)
    
    // await reader.close();

    // close the ZipReader
    // await reader.close();

    //     const zip = new JSZip();
    // zip.file("Hello.txt", data);
    // // const img = zip.folder("images");
    // // img.file("smile.gif", imgData, {base64: true});
    // zip.generateAsync({type:"blob"})
    // .then(function(content) {
    //     // see FileSaver.js
    //     saveAs(content, "example.zip");
    // });

    //     const fs = require("fs");
    //     console.log("fs = ", fs);
    //     const path = require("path");
    //     console.log("path = ", path);
    //     const request = require("request");
    //     console.log("request = ", request);

    //     //创建文件夹目录
    // const dirPath = path.join(__dirname, "TestFiles");
    // console.log("dirPath = ", dirPath);

    // if (!fs.existsSync(dirPath)) {
    //   fs.mkdirSync(dirPath);
    //   console.log("文件夹创建成功");
    // } else {
    //   console.log("文件夹已存在");
    // }
    // let i = 0
    // let timer = setInterval(() => {
    //   let url = data;
    //   i++;
    //   let fileName = url.split('/').pop();
    //   let stream = fs.createWriteStream(path.join(dirPath, fileName));
    //   request(url).pipe(stream).on("close", function (err) {
    //     console.log("err = ", err);
    //     console.log("第" + i + "个文件[" + fileName + "]下载完毕");
    //   });
    //   if(i>=data.length) clearInterval(timer)
    // }, 500 + Math.random() * 1000)

    //https://oss-cn-shanghai.aliyuncs.com
    // const d = await getUrlData(data, true);
    // console.log("getJSONData d======== ", d);
    // const files = new window.File([data], "tester", {type: 'zip'})
    // console.log("files = ", files)

    // // const _that = this;
    // const selectedFile = files
    // // 读取文件名
    // const name = selectedFile.name
    // console.log("name ===== ", name)
    // // 读取文件大小
    // const size = selectedFile.size
    // console.log("size ===== ", size)
    // // FileReader对象，h5提供的异步api，可以读取文件中的数据。
    // const reader = new FileReader()
    // // readAsText是个异步操作，只有等到onload时才能显示数据。
    // reader.readAsDataURL(selectedFile)
    // reader.onload = function () {
    //   //当读取完成后回调这个函数,然后此时文件的内容存储到了result中,直接操作即可,此处this指向reader，_that指向vue data，this.result就是文件的内容
    //   console.log("this.result ===== ", this.result)
    //   // _that.coder.setValue(this.result)
    // }

    // JSZip.loadAsync(files).then((zip) => {
    //             for (let key in zip.files) {
    //             // 用blob的格式读取，方便后面下载到本地
    //               let base = zip.file(zip.files[key].name).async('blob')
    //               base.then(res => {
    //                console.log("res = ", res)
    //               })
    //             }
    //           })

    // const zipData = await JSZip.loadAsync(files)
    // console.log("loadAsync = ", zipData.files)
    // this.largeuint8ArrToString(data, function(text){
    // // Hello
    // console.log("text == ", text);

    // });
    // saveAs('https://www.baidu.com/img/PCtm_d9c8750bed0b3c7d089fa7d55720d6cf.png')
    // const blob = new Blob(['Hello, world!'])
    // saveAs(blob, 'hello world.txt')

    // const zip = new JSZip()
    // zip.folder("sub").file("file.txt", data)
    // console.log("zip = ", zip)
    // console.log("im = ", im)

    // function getZipFiles(zipUrl) {  const response = await axios({    method: 'get',    url: zipUrl,    responseType: 'arraybuffer'  // 类型必须为arraybuffer  });  // loadAsync加载其他类型资源会出问题，比如资源乱码  const zipData = await JSZip.loadAsync(response.data);  return zipData.files;}

    // const bloburl = data
    // const name = "hello.txt"
    // const anchor = document.createElement("a");
    // if ('download' in anchor) {
    //     anchor.style.visibility = "hidden";
    //     anchor.href = bloburl;
    //     anchor.download = name;
    //     document.body.appendChild(anchor);
    //     const evt = document.createEvent("MouseEvents");
    //     evt.initEvent("click", true, true);
    //     anchor.dispatchEvent(evt);
    //     document.body.removeChild(anchor);
    //     console.log("--------------------------------")
    // }
    // else if (navigator.msSaveBlob) {
    //     navigator.msSaveBlob(blob, name);
    // } else {
    //     location.href = bloburl;
    // }

    // const str = String.fromCharCode.apply(null, data[0]);
    // const res = JSON.parse(str);
    // console.log(res.AccessKeySecret);
    // const mm =  new TextDecoder("utf-8").decode(data);
    // console.log("mm mm======== ", mm);
    // let binary = '';
    // const bytes = data
    // const len = bytes.byteLength;
    // for (let i = 0; i < len; i++) {
    //   binary += String.fromCharCode( bytes[ i ] );
    // }
    // //  window.btoa( binary );
    // console.log("binary ====== ", window.btoa( binary ))
    //String.fromCharCode.apply(null, myUint8Arr);
    // for (const m in data) {
    //   console.log("m = ", m)
    // }
    // console.log("String.fromCharCode.apply = ", String.fromCharCode.apply(null, data[0]))
    // let dataString = "";
    // const fileData = data
    // for (var i = 0; i < fileData.length; i++) {
    //   dataString += String.fromCharCode(fileData[i]);
    // }
    // console.log("dataString = ", dataString)
    // const utf8decoder = new TextDecoder()
    // console.log(utf8decoder.decode( data[0]));

    // require('fast-text-encoding');  // just require me before use

    // const buffer = new fastText
    //  console.log("buffer ======== ", buffer);
    // const str = String.fromCharCode.apply(null, data.content);
    // const res = JSON.parse(str);
    // console.log(res.AccessKeySecret);
    // const da = await getJSONData(data);
    // console.log("downLoadFile da======== ", da);
    //const url = encodeURIComponent(data)
    // const a = document.createElement("a");
    // a.href = data;
    // a.download = data;
    // a.click();
  },
};
</script>
<style lang='less' scoped>
</style>